import { createApp } from 'vue'
import { LoadGeneral } from '@core/global'
import router from '@/router'
import App from '@/App.vue'

const app = createApp(App)

app.use(LoadGeneral)
app.use(router)

app.mount('#app')

